import { graphql } from "@/lib/gql/__generated__/gql";

export const HOTEL_QUERY = graphql(/* GraphQL */ `
	query HotelForReOnboardingRequestQuery($hotelID: ID!) {
		hotel(hotelID: $hotelID) {
			hotelID
			email
		}
	}
`);
